export default "__VITE_ASSET__a1f4889c__"